import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { WORKSPACE_SERVICE_URI } from '@cores/constants/envConfig';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
let SpacesApiImpl = class SpacesApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${WORKSPACE_SERVICE_URI}/workspace/web`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async stickSpace(spaceId) {
        const res = await this.put({
            url: `/space/${spaceId}/stick`,
            transformCode: true,
        });
        return res;
    }
    async unstickSpace(spaceId) {
        const res = await this.put({
            url: `/space/${spaceId}/against-stick`,
            transformCode: true,
        });
        return res;
    }
    async getSpaceCooperation(spaceId) {
        const res = await this.get({
            url: `/space/${spaceId}/share-user`,
            transformCode: true,
        });
        return res.data;
    }
    async getAvatarInfo(userIds) {
        const res = await this.post({
            url: 'user/avatar-info',
            data: {
                user_ids: userIds,
            },
            transformCode: true,
        });
        return res.data;
    }
};
SpacesApiImpl = __decorate([
    injectable()
], SpacesApiImpl);
export { SpacesApiImpl };
